import { render } from "./Travail_mecanique_corps_mvt.vue?vue&type=template&id=db36d79e&scoped=true&ts=true"
import script from "./Travail_mecanique_corps_mvt.vue?vue&type=script&lang=ts"
export * from "./Travail_mecanique_corps_mvt.vue?vue&type=script&lang=ts"

import "./Travail_mecanique_corps_mvt.vue?vue&type=style&index=0&id=db36d79e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db36d79e"]])

export default __exports__